import { createReactComponent } from '@tabler/icons-react';

export const IconCustomExportRestore = createReactComponent(
  'outline',
  'customExportRestore',
  'CustomExportRestore',
  [
    [
      'path',
      {
        key: 'customExportRestore-path',
        d: 'M15 8V7C15 6.4695 14.7893 5.9608 14.4142 5.5857C14.0392 5.2107 13.5305 5 13 5H5C4.4696 5 3.9609 5.2107 3.5858 5.5857C3.2107 5.9608 3 6.4695 3 7V17C3 17.5304 3.2107 18.0391 3.5858 18.4141C3.9609 18.7892 4.4696 19 5 19H13C13.5305 19 14.0392 18.7892 14.4142 18.4141C14.7893 18.0391 15 17.5304 15 17V16M21 12L18 9M21 12L18 15M21 12H16.5M6.3938 10.8317C6.6586 10.1962 7.1249 9.6653 7.7211 9.3209C8.3172 8.9765 9.01 8.8377 9.6928 8.9258C10.3757 9.0139 11.0106 9.324 11.4997 9.8085C11.7248 10.0314 11.9133 10.2854 12.0604 10.5612M6.2001 9.2817V10.8317H7.75M12.2063 13.1567C11.9415 13.7922 11.4752 14.3231 10.879 14.6675C10.2829 15.0119 9.5901 15.1507 8.9073 15.0626C8.2244 14.9744 7.5895 14.6644 7.1004 14.1799C6.9091 13.9906 6.7443 13.7786 6.6088 13.55M12.4001 14.7067V13.1567H10.8501',
      },
    ],
  ]
);
